// "Apps Are Dying (I Have Receipts)" — ep 47. Cold Compute / Neon kit.
// FIRST EPISODE WITH A REAL RECORDED VO TRACK: 9 clips in public/vo/47/,
// timed off ffprobe durations (2026-08-30). Each block's Sequence carries its
// own <Audio>; block frame lengths = ceil(clipSeconds * 30).
//
// GROUNDED in EAKC-MVP docs/video-scripts/2026-08-29-apps-are-dying-receipts.md (v4):
//   - Receipts week (Cautious Optimism 2026-08-28): Claudeforce (Salesforce×Anthropic,
//     37 governed skills inside Claude), Agentforce $1.5B ARR, AI+data ~$4B,
//     3.2B Agentic Work Units +97% QoQ, Stripe bought OpenRouter, MCP Apps
//     (SEP-1865, Anthropic+OpenAI, ratified 2026-01-26).
//   - EAKC three-point vision (2026-08-28 reconciliation VC): embeddable widgets
//     (shipped), MCP-served widgets (Gate 1 live-verified 2026-07-02; re-probed
//     2026-08-30: 26/26 PASS incl. the query_eakc flagship widget), the
//     auto-doc "employee" (NOT built — the honest 30%).
//   - Segment 3: nearness ≠ existence (chat audit 2026-08-26), negative-evidence
//     rule, ADOPT 5 / HAVE 4 / REJECT 1, "recency is not applicability".
//   - Segment 4 accuracy contract (metadata.md + the script's production note 6):
//     ONLY the 08:00 UTC self-sync + the operator's change-digest mission are
//     claimable; auto-writing docs is explicitly "not built yet".
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Block frame-timing map. start/duration in frames @30fps; contiguous.
// Durations come from the recorded VO clips — do NOT retime without re-probing audio.
export const BLOCK = {
  hook: { start: 0, duration: 1208 }, //          0:00–0:40  hook.mp3      (40.24s)
  s1setup: { start: 1208, duration: 359 }, //     0:40–0:52  s1-setup.mp3  (11.95s)
  s1tension: { start: 1567, duration: 526 }, //   0:52–1:10  s1-tension.mp3 (17.51s)
  s1broll: { start: 2093, duration: 700 }, //     1:10–1:33  s1-broll.mp3  (23.33s)
  s1onscreen: { start: 2793, duration: 1016 }, // 1:33–2:07  s1-onscreen.mp3 (33.87s)
  s1payoff: { start: 3809, duration: 456 }, //    2:07–2:22  s1-payoff.mp3 (15.19s)
  seg2: { start: 4265, duration: 2891 }, //       2:22–3:59  seg2.mp3      (96.34s)
  seg3: { start: 7156, duration: 2965 }, //       3:59–5:37  seg3.mp3      (98.81s)
  seg4: { start: 10121, duration: 3365 }, //      5:37–7:29  seg4.mp3      (112.15s)
  endcard: { start: 13486, duration: 300 }, //    7:29–7:39  NO VO YET (CTA not recorded)
} as const;

export const TOTAL_DURATION = 13786; // ~459.5s ≈ 7:40

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
